export default __webpack_public_path__ + "static/media/reset-password.1583efa0.png";